import { Box, Table, Text } from "@chakra-ui/react";
import { useId } from "react";
import { formatNumber } from "../../../../store/helpers";
import LineGraph from "../../../daily/LineGraph";

const formatDecimal = (value) => Number(value || 0).toFixed(2);

const ArrivalRatesPerServiceTable = ({ index, serviceData, reportIndex }) => {
  const id = useId();

  const { min, max, total, average, serviceName, totalPct, chart } =
    serviceData;
  const heading = `${serviceName}`;
  const title = `${reportIndex || ""}.${index + 1}. ${heading}`;
  return (
    <Box key={index} className="reportContainer" mt="20px">
      <h3>
        {title}
        {!total && <Text fontSize="sm">No data available for this report</Text>}
      </h3>

      <Box>
        {total ? (
          <>
            <Table.Root className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader>#</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total</Table.ColumnHeader>
                  <Table.ColumnHeader>Average</Table.ColumnHeader>
                  <Table.ColumnHeader>Min</Table.ColumnHeader>
                  <Table.ColumnHeader>Max</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row key={id}>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    {" "}
                    <Text color={"var(--green)"}>
                      {total}
                      <Text
                        color="gray.500"
                        fontWeight="semibold"
                        fontSize="xs"
                        textTransform="uppercase"
                      >
                        ({totalPct.toFixed(2)}%)
                      </Text>
                    </Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text color={"var(--blue)"}>{formatDecimal(average)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text color={"var(--blue)"}>{formatNumber(min)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text color={"var(--blue)"}>{formatNumber(max)}</Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
            <Box className="arrivalRatesPerServiceChartBlock">
              <LineGraph
                chart={chart}
                height={"300px"}
                title={`Entire Organization: ${serviceName} Arrival Rates, Hour by Hour Comparison`}
              />
            </Box>
          </>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export default ArrivalRatesPerServiceTable;
